import React, { useContext } from 'react';
import { Product } from '../../config/products';

// @ts-ignore
export const ProductContext = React.createContext<Product>(undefined);

export function useProductContext(): Product {
  return useContext(ProductContext);
}
